import * as d3 from 'd3'
export default {
  methods: {

    call_TableOver(selection, tbl) {

      if(tbl.TYPE == 'Excel') return

      let this_ = this
      let usedService = this.db_Service.filter(f => f.DATABASE == tbl.DATABASE && f.SCHEMA == tbl.SCHEMA && f.TABLE == tbl.NAME)
      // console.log(usedService) // ----->

      const uniqueService = [
        ...new Set(usedService.map(m => `${m.PHASE}|${m.GROUP}|${m.ITEM}`))
      ].map(key => {
        const [PHASE, GROUP, ITEM] = key.split('|')
        return { PHASE, GROUP, ITEM }
      })
      // console.log(usedService) // ----->

      selection
     .attr('cursor', 'pointer').attr('opacity', 1)
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .4)

        uniqueService.forEach(d=> {
          let idx = this_.db_Navigation.find(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM).IDX
          let count = usedService.filter(f=>f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM).length
          if(idx) d3.select(`#ITEM_${idx}`).attr('fill', '#EC407A').text(`${d.ITEM} (${count})`)
        })
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)

        uniqueService.forEach(d=> {
          let idx = this_.db_Navigation.find(f=> f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM).IDX
          let count = this_.service.usedList.filter(f=>f.PHASE == d.PHASE && f.GROUP == d.GROUP && f.ITEM == d.ITEM).length
          if(idx) d3.select(`#ITEM_${idx}`).attr('fill', '#44A9DF').text(`${d.ITEM} (${count})`)
        })
      })
      .on('click', () => {
      })
    },

    call_ServiceItem(selection, item) {
      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', ()=> {
      })
    },

  }
}